export const SHOW_ANNOUNS_BLOCK = (state) => {
  state.showAnnouns = true;
}

export const HIDE_ANNOUNS_BLOCK = (state) => {
  state.showAnnouns = false;
}

export const SHOW_NOTIFS_BLOCK = (state) => {
  state.showNotifs = true;
}

export const HIDE_NOTIFS_BLOCK = (state) => {
  state.showNotifs = false;
}

export const SHOW_REMS_BLOCK = (state) => {
  state.showRems = true;
}

export const HIDE_REMS_BLOCK = (state) => {
  state.showRems= false;
}

export const SET_COLOR_SCHEME = (state, val) => {
  state.colorScheme = val;
}

export const SET_CLIENT_FEATURES = (state, val) => {
  state.clientFeatures = val;
}

export const SET_PROVIDER_FEATURES = (state, val) => {
  state.providerFeatures = val;
}